module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-navigation-drawer', {
    class: {
      'hidden-md-and-up': _vm.isMdAndUp
    },
    attrs: {
      "temporary": "",
      "absolute": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(item, i) {
    return (item.publico || (_vm.logged && (item.id !== 3 || _vm.permissaoCriarProjetoExtensao === true))) ? _c('v-list-item', {
      key: i,
      attrs: {
        "to": {
          name: item.link
        }
      }
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.text))])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.logged) ? _c('v-list-item', {
    on: {
      "click": _vm.PERFORM_LOGOUT
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Sair")])], 1)], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "text": "",
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "tile": true,
      "size": "50px"
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/logo_ufes.png'),
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('v-app-bar-nav-icon', {
    class: {
      'hidden-md-and-up': _vm.isMdAndUp
    },
    attrs: {
      "app": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Portal dos Projetos")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down text-xs-right"
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.publico || (_vm.logged && item.id === 1) || (_vm.permissaoCriarProjetoExtensao && item.id === 3) || (_vm.administrador && item.id === 4)) ? _c('v-btn', {
      key: i,
      attrs: {
        "text": "",
        "to": {
          name: item.link
        }
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.logged) ? _c('span', [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("account_circle")]), _vm._v("\n      " + _vm._s(_vm.username) + " ("), _c('a', {
    staticClass: "nav_link",
    on: {
      "click": function($event) {
        return _vm.PERFORM_LOGOUT()
      }
    }
  }, [_c('strong', [_vm._v("sair")])]), _vm._v(")\n    ")], 1) : _c('span', [_vm._v("\n      Por favor, realize o "), _c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea57fd3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-layouts/menu.vue
// module id = 236
// module chunks = 0